module.exports = __webpack_public_path__ + "img/IDS_login.d86039a1.png";